import { UiGridItem } from './ui-grid-item';
import { ImageMedia, NestedProperty } from '@madeinlune/drupal-types';
import { Expose, Type } from 'class-transformer';

export class UiArticleGridItem extends UiGridItem {
  @Type(() => ImageMedia)
  @Expose()
  media: ImageMedia | undefined;

  @Expose({ name: 'baseline' })
  override title: string | undefined;

  @NestedProperty('color.color')
  @Expose()
  color: string | undefined;

  @Expose()
  override get backgroundColor(): string | undefined {
    if (this.color) {
      return this.color;
    } else if (this.thumb instanceof ImageMedia) {
      return this.thumb.average_colors?.average_color;
    }
    return undefined;
  }

  @Expose()
  override get isDarkBackground(): boolean | undefined {
    if (this.thumb instanceof ImageMedia) {
      return this.thumb.average_colors?.isDark;
    }
    return undefined;
  }

  @Expose()
  promote: boolean | undefined;

  @Expose({ name: 'date_only' })
  date: string | undefined;
}
